import "./Level2.scss";

export default function Level2() {
  return (
    <div className="level2__container">
      <div className="level2__puzzle">
        <div className="level2__file">
          <p className="level2__letter">A</p>
          <p className="level2__clue">D</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">B</p>
          <p className="level2__clue">E</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">C</p>
          <p className="level2__clue">F</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">D</p>
          <p className="level2__clue">G</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">E</p>
          <p className="level2__clue">H</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">F</p>
          <p className="level2__clue">I</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">G</p>
          <p className="level2__clue">J</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">H</p>
          <p className="level2__clue">K</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">I</p>
          <p className="level2__clue">L</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">J</p>
          <p className="level2__clue">M</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">K</p>
          <p className="level2__clue">N</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">L</p>
          <p className="level2__clue">O</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">M</p>
          <p className="level2__clue">P</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">N</p>
          <p className="level2__clue">Q</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">O</p>
          <p className="level2__clue">R</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">P</p>
          <p className="level2__clue">S</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">Q</p>
          <p className="level2__clue">T</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">R</p>
          <p className="level2__clue">U</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">S</p>
          <p className="level2__clue">V</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">T</p>
          <p className="level2__clue">W</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">U</p>
          <p className="level2__clue">X</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">V</p>
          <p className="level2__clue">Y</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">W</p>
          <p className="level2__clue">Z</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">X</p>
          <p className="level2__clue">A</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">Y</p>
          <p className="level2__clue">B</p>
        </div>
        <div className="level2__file">
          <p className="level2__letter">Z</p>
          <p className="level2__clue">C</p>
        </div>
      </div>

      <div className="level2__guess-container">
        <span className="level2__guess">
          HQFULSWDU
        </span>
      </div>
    </div>
  );
}
